import {FeatureName} from '@contentlab/types/project';

const FEATURE_ASSETS = {
  [FeatureName.REFORMATTING]: {
    IMAGE:
      'https://storage.googleapis.com/brands-public-assets/content-lab/Reformat.jpg?v=2',
    VIDEO:
      'https://storage.googleapis.com/brands-public-assets/content-lab/Reformat.mp4',
  },
  [FeatureName.AI_DUBBING]: {
    IMAGE:
      'https://storage.googleapis.com/brands-public-assets/content-lab/Translate.jpg?v=2',
    VIDEO:
      'https://storage.googleapis.com/brands-public-assets/content-lab/Translate.mp4',
  },
  [FeatureName.REPHRASING]: {
    IMAGE:
      'https://storage.googleapis.com/brands-public-assets/content-lab/Rephrase.jpg?v=2',
    VIDEO:
      'https://storage.googleapis.com/brands-public-assets/content-lab/Rephrase.mp4',
  },
  [FeatureName.CAPTIONS]: {
    IMAGE:
      'https://storage.googleapis.com/brands-public-assets/content-lab/Captions.jpg?v=2',
    VIDEO:
      'https://storage.googleapis.com/brands-public-assets/content-lab/Captions.mp4',
  },
  [FeatureName.UPSCALE]: {
    // TODO: update assets when available
    IMAGE: '',
    VIDEO: '',
  },
  [FeatureName.AI_AVATAR]: {
    IMAGE:
      'https://storage.googleapis.com/brands-public-assets/content-lab/AiAvatar.png?v=2',
    VIDEO:
      'https://storage.googleapis.com/brands-public-assets/content-lab/AiAvatar.mp4',
  },
};

export default FEATURE_ASSETS;
